export default __webpack_public_path__ + "static/media/Banner2022_Retail-min.abf4b2fa.png";